export default __webpack_public_path__ + "static/media/sidebar-5.ae5c1d76.jpeg";